export default "__VITE_ASSET__D7U9wZzS__"